// background settings:

import { Box, FormField, Select, Tab, Tabs, TextInput } from "grommet"
import { SettingType } from "./utils/SettingType"
import { ImageSettingsForm } from "./sections/ImageSettingsForm"
import { RulerSquare } from "../../../icons/RulerSquare"
import { BoxShadow } from "../../../icons/BoxShadow"
import ShadowSettingsForm from "./sections/ShadowSettingsForm"
import { Close, Image, Paint } from "grommet-icons"
import { rouletteItemBgType } from "../RouletteConstants"
import { useContext, useState } from "react"
import { FormTypeContext } from "./tab/RouletteItemDesignTab"
import RangeInputWithEdit from "../../../forms/RangeInputWithEdit"
import { useDebounce } from "rooks"
import { useTranslation } from "react-i18next"

/*
- None: radius
- Image: image, radius, hue, saturation, shadow
- Color: radius, color1, color2, angle, shadow
*/

const typeOptions = [
    { labelKey: 'optionNone', icon: <Close/>, value: rouletteItemBgType.NONE },
    { labelKey: 'optionImage', icon: <Image/>, value: rouletteItemBgType.IMAGE },
    { labelKey: 'optionColorGradient', icon: <Paint/>, value: rouletteItemBgType.COLOR },
]

const RouletteBackgroundSettings = () => {
    
    const { t } = useTranslation('roulette');
    const { backgroundType: type } = useContext(FormTypeContext);
    
    return (
        <Box gap="medium">
            <FormField label={t('typeLabel')}>
                <Select
                    name="backgroundType"
                    options={typeOptions} 
                    labelKey={(option) => <SettingType option={{ ...option, label: t(option.labelKey) }} />}
                    valueKey={{ key: 'value', reduce: true }}
                    // value={type}
                    // onChange={({ value }) => setType(value)}
                />
            </FormField>
            {type !== rouletteItemBgType.NONE && <BackgroundSettingsForm type={type} />}
        </Box>
    )
}

const BackgroundSettingsForm = ({ type }) => {

    const { t } = useTranslation('roulette');

    return (
        <Box>
            <Tabs>
                <Tab title={type === rouletteItemBgType.IMAGE ? t('imageTabTitle') : t('colorTabTitle')} icon={type === rouletteItemBgType.IMAGE ? <Image/> : <Paint />}>
                    {type === rouletteItemBgType.IMAGE && <ImageSettingsForm label={t('backgroundLabel')} title={t('backgroundBtnLabel')} imageInputName="backgroundImage" imageHueInputName="backgroundImageHueRotate" imageSaturationInputName="backgroundImageSaturate" category="roulette_background" />}
                    {type === rouletteItemBgType.COLOR && <ColorSettingsForm />}
                </Tab>
                <Tab title={t('sizeTabTitle')} icon={<RulerSquare />}>
                    <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
                        <FormField label={t('radiusLabel')} noBorder noFocus>
                            <RangeInputWithEdit name="backgroundRadius" type="number" unit={'px'} min={0} max={100} step={1} />
                        </FormField>
                    </Box>
                </Tab>
                <Tab title={t('shadowTabTitle')} icon={<BoxShadow />}>
                    <ShadowSettingsForm 
                        shadowColorInputName="backgroundShadowColor"
                        shadowHorizontalOffsetInputName="backgroundShadowHorizontalOffset"
                        shadowVerticalOffsetInputName="backgroundShadowVerticalOffset"
                        shadowBlurInputName="backgroundShadowBlur"
                    />
                </Tab>
            </Tabs>
        </Box>
    )
}

const ColorSettingsForm = () => {

    const { t } = useTranslation('roulette');

    return (
        <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
            <FormField label={t('color1Label')}>
                <TextInput name="backgroundColor1" type="color" />
            </FormField>
            <FormField label={t('color2Label')}>
                <TextInput name="backgroundColor2" type="color" />
            </FormField>
            <FormField label={t('angleLabel')} noBorder noFocus>
                <RangeInputWithEdit name="backgroundColorAngle" type="number" unit={'°'} min={0} max={360} step={1} />
            </FormField>
        </Box>
    )
}

export default RouletteBackgroundSettings;
